import History from 'history';
import { runInAction } from 'mobx';
import { BasePath, pagePathToPathString } from 'services/base/page_path';
import { PaymentRedirect, PaymentRedirectType } from 'services/base/redirect_types';
import { UnreachableFunction } from 'ui/base/types';

export function redirectByPayment(history: History.History, redirect: PaymentRedirect): boolean {
  return runInAction(() => {
    switch(redirect.type) {
      case PaymentRedirectType.PLAN:
        return redirectByPlanPayment(history, redirect);
      default:
        return UnreachableFunction(redirect.type);
    }
  });
}

function redirectByPlanPayment(history: History.History, redirect: PaymentRedirect): boolean {
  history.replace(pagePathToPathString({
    kind: BasePath.HOME,
    pangolinID: redirect.pangolin,
  }));

  history.push(pagePathToPathString({
    kind: BasePath.PLANS,
    pangolinID: redirect.pangolin,
  }));

  return true;
}
